import React from "react";
import styled from "styled-components";
import { OrderLineItem } from "../../../../types/Order/OrderLineItem";
import { Currency } from "../../../../constant/Currency";
import TableActionButton from "../../../../@ui/TableActionButton";
import Price from "../../../../@ui/Price";

interface LineItemsProps {
  items: OrderLineItem[];
  currency: Currency;
  inclTax?: boolean;
  onDownload: (id: string) => void;
}

const Details = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.2rem;
`;

const PriceField = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  justify-content: center;
`;

const Description = styled.p`
  color: #a0a0a0;
  margin-bottom: 0;
`;

const ItemGrid = styled.div`
  display: grid;
  grid-template-columns: 7fr 1fr;
  border-top: 1px solid lightGrey;
  width: 100%;
  gap: 20px;
  padding: 0.5rem 0rem;
`;

const Layout = styled.div`
  border-bottom: 1px solid lightGrey;
`;

const getDescription = (description: string): string => {
  if (!description.includes("FeatureType")) return description;
  const lastIndex = description.lastIndexOf(":");
  if (lastIndex === -1) return description; 
  const firstPart = description.substring(0, lastIndex);
  const secondPart = description
    .substring(lastIndex + 1)
    .replace(/([a-z])([A-Z])/g, "$1 $2")
    .trim();

  return `${firstPart}: (${secondPart})`;
};

const LineItems = ({ items, onDownload }: LineItemsProps) => {
  return (
    <Layout>
      {items.map((x, i) => (
        <ItemGrid key={i}>
          <Details>
            <p className="mb-0">{x.layerName}</p>
            <Description>{getDescription(x.description)}</Description>
            <TableActionButton
              onClick={() => onDownload(x.id)}
              className="w-25">
              Download
            </TableActionButton>
          </Details>
          <PriceField>
            <p>
              <Price
                currencyCode={x.transactionCurrencyCode}
                price={x.priceExTax}
              />
            </p>
          </PriceField>
        </ItemGrid>
      ))}
    </Layout>
  );
};

export default LineItems;
